import { render, staticRenderFns } from "./WrapperFromVaccinePricingAndDosesDistribution.vue?vue&type=template&id=7063e793&"
import script from "./WrapperFromVaccinePricingAndDosesDistribution.vue?vue&type=script&lang=js&"
export * from "./WrapperFromVaccinePricingAndDosesDistribution.vue?vue&type=script&lang=js&"
import style0 from "./WrapperFromVaccinePricingAndDosesDistribution.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports